import { useDispatch } from "react-redux";
import DesignationTimelineSvg from "./DesignationTimelineSVG";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import tw from "tailwind-styled-components";
import WeeklyWorkingDayAddSinglePopup from "./PopUp/WeeklyWorkingDayAddPopup";
import WeeklyWorkingEditSinglePopup from "./PopUp/WeeklyWorkingDayEditPopup";


const WeeklyWorkingDaysStatus = ({ list, edit, setLoading }) => {
  const user_id = useParams("id");
  const dispatch = useDispatch();

  const deletedWeeklyWorkingDaysHistory = async (id) => {
    setLoading(true);
    //   const { data } = await dispatch(deleteWeeklyWorkingDaysHistory(id));
    //   if (data.message === "success") {
    //     dispatch(loadSingleStaff(user_id.id));
    //     setLoading(false);
    //   } else {
    //     setLoading(false);
    //   }
  };

  const WeeklyWorkingDaysList = Array.isArray(list) ? list : (list ? [list] : []);

  return (
    <div>
      <main className="container mx-auto w-full flex justify-center mt-5">
        <ol className="border-l-2 border-slate-600">
          {WeeklyWorkingDaysList.length > 0 &&
            WeeklyWorkingDaysList.map((item, index) => (
              <li key={index}>
                <div className="md:flex flex-start">
                  <DesignationTimelineSvg />
                  <div className="block p-6 max-w-md ml-6 mb-5">
                    <div className="flex justify-between mb-4">
                      <Heading>{item?.WeeklyWorkingDaysName}</Heading>
                      <Heading>
                        {dayjs(item?.EffectedFrom).format("MMM YYYY")} -{" "}
                        {item?.EffectedTo
                          ? dayjs(item?.EffectedTo).format("MMM YYYY")
                          : "Present"}
                      </Heading>
                      {edit && (
                        <div>
                          <WeeklyWorkingEditSinglePopup
                            data={item}
                            setLoading={setLoading}
                          />
                          <button
                            onClick={() =>
                              deletedWeeklyWorkingDaysHistory(item.WeeklyWorkingDaysHistoryId)
                            }
                          >
                            {/* <BtnDeleteSvg size={20} /> */}
                          </button>
                        </div>
                      )}
                    </div>
                    <Heading1>
                      Start Date:{" "}
                      <Heading2>
                        {item?.EffectedFrom ? dayjs(item?.EffectedFrom).format("DD/MM/YYYY") : "N/A"}
                      </Heading2>
                    </Heading1>
                    <Heading1>
                      End Date:{" "}
                      <Heading2>
                        {item?.EffectedTo ? dayjs(item?.EffectedTo).format("DD/MM/YYYY") : "Present"}
                      </Heading2>
                    </Heading1>
                    <Heading1>
                      Working Days:{" "}
                      <Heading2>
                        {item?.StartDayName} - {item?.EndDayName}
                      </Heading2>
                    </Heading1>
                    <Heading1>
                      Special Week Off:{" "}
                      <Heading2>
                        {item?.SpecialWeekOffNames || "N/A"}
                      </Heading2>
                    </Heading1>
                    <Heading1>
                      Special Days Off:{" "}
                      <Heading2>
                        {item?.SpecialDaysOffNames || "N/A"}
                      </Heading2>
                    </Heading1>
                  </div>
                </div>
              </li>
            ))}
          {WeeklyWorkingDaysList.length === 0 && (
            <div className="p-4 text-center">
              No Weekly Working Days history available
            </div>
          )}
        </ol>
      </main>
    </div>
  );
};

const Heading = tw.h3`
font-medium
text-base
mr-20
w-500
txt-color-2
`;

const Heading1 = tw.h3`
font-medium
text-sm
mr-20
w-500
txt-color-2
`;

const Heading2 = tw.span`
font-medium 
text-sm
txt-color-secondary`;

export default WeeklyWorkingDaysStatus;